import { useGetPublicConfigsQuery } from '@/services/ApiService';

export const useFrontendConfigs = () => {
    const { data, isFetching, isError } = useGetPublicConfigsQuery();

    return {
        configs: data || {},
        isFetching,
        isError,
    };
};
